import { render, staticRenderFns } from "./LivePreview.vue?vue&type=template&id=c460ce9c&scoped=true"
import script from "./LivePreview.vue?vue&type=script&lang=js"
export * from "./LivePreview.vue?vue&type=script&lang=js"
import style0 from "./LivePreview.vue?vue&type=style&index=0&id=c460ce9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c460ce9c",
  null
  
)

export default component.exports